/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { UserPostInput } from '../../models/user-post-input';

export interface UsersPost$Params {

/**
 * Required if creating a "regular" user. Not required if creating a reseller user.<br>
 * Reseller users must include "resellerId" in the request body.
 */
  'Active-Tenant-Identifier'?: string;
      body: UserPostInput
}

export function usersPost(http: HttpClient, rootUrl: string, params: UsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
  const rb = new RequestBuilder(rootUrl, usersPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      }>;
    })
  );
}

usersPost.PATH = '/users';
